import React from 'react';
import { LinkedModal } from '../../form/search/LinkedModal';

export const EqMagnitudeModal = {
  title: 'Earthquake Magnitude',
  body:
  <div>
    <div>
      Valid values:
      {' '}
      <b>0.0 to 9.9</b>
    </div>
    <br />
    <p>
      The value in this column contains the primary earthquake magnitude.
      Magnitude measures the energy released at the source of the earthquake.
      Magnitude is determined from measurements on seismographs. For
      pre-instrumental events, the magnitudes are derived from intensities.
      There are several different scales for measuring earthquake magnitudes.
      The primary magnitude is chosen from the available magnitude scales in
      this order:
    </p>
    <LinkedModal helpModalId="eqMwMag">Mw Magnitude</LinkedModal>
    <LinkedModal helpModalId="eqMsMag">Ms Magnitude</LinkedModal>
    <LinkedModal helpModalId="eqMbMag">Mb Magnitude</LinkedModal>
    <LinkedModal helpModalId="eqMlMag">Ml Magnitude</LinkedModal>
    <LinkedModal helpModalId="eqMfaMag">Mfa Magnitude</LinkedModal>
    <LinkedModal helpModalId="eqUnkMag">Unknown Magnitude</LinkedModal>
  </div>,
};
